// extracted by mini-css-extract-plugin
module.exports = {"rating-table__breadcrumbs-wrap":"_9e1425b4d3--rating-table__breadcrumbs-wrap--tszt0"};